import { render, staticRenderFns } from "./InputTextareaCpt.vue?vue&type=template&id=b42f3fc0&scoped=true&"
import script from "./InputTextareaCpt.vue?vue&type=script&lang=ts&"
export * from "./InputTextareaCpt.vue?vue&type=script&lang=ts&"
import style0 from "./InputTextareaCpt.vue?vue&type=style&index=0&id=b42f3fc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42f3fc0",
  null
  
)

export default component.exports